/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

const {wrapRootElement} = require('./wrap-root-with-provider');
module.exports.wrapRootElement = wrapRootElement;
